import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  responseContainer: {
    backgroundColor: designTokens.neutral[100],
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    ...shorthands.padding(designTokens.spacing[3]),
    fontSize: designTokens.fontSize.sm,
    "& h1, & h2, & h3": {
      fontSize: designTokens.fontSize.base,
      fontWeight: designTokens.fontWeight.bold,
      ...shorthands.margin("0"),
    },
    "& h4, & h5, & h6": {
      fontSize: designTokens.fontSize.sm,
      fontWeight: designTokens.fontWeight.semibold,
      ...shorthands.margin("0"),
    },
  },
});
